module.exports = __webpack_public_path__ + "static/img/69-3.5253263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/69-3.jpg
// module id = nl37
// module chunks = 0